<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="isMulti ? filteredOptions : options"
    :custom-label="labelEstabelecimento"
    :multiple="isMulti"
    :class="isMulti ? 'multiselect-primary' : ''"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="preselectFirst"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    :loading="isLoading"
    placeholder=""
  >
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="multiselect__tag">
        <span v-if="option">{{ option.numero }} - {{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    localidadeSelected: {},
    secaoSelected: {},
    rotaSelected: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    isMulti: { type: Boolean, default: false },
    preselectFirst: { type: Boolean, default: false },
    isContaCorrente: { type: Boolean, default: false },
    hasPos: { type: Boolean, default: false },
    aditionalColumns: {}
  },

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  computed: {
    filteredOptions() {
      return this.options.filter((option) => !this.selected.includes(option));
    }
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_estabelecimento', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_estabelecimento', arr);
      } else {
        this.isObject
          ? this.$emit('selectChange', 'id_estabelecimento', e)
          : this.$emit('selectChange', 'id_estabelecimento', e.id);
      }
    },
    labelEstabelecimento({ nome, numero }) {
      return numero ? `${numero} - ${nome}` : `${nome}`;
    },
    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            const elem = this.options.find((option) => option.id === el);
            if (elem) this.selected.push(elem);
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        if (this.includeAll) {
          this.selected = this.options.find((option) => option.id === null);
        } else {
          this.isMulti ? (this.selected = []) : (this.selected = '');
        }
      }

      this.preselectFirst && !this.isMulti ? this.preselectFirstCheck() : null;
      this.onChange(this.selected);
      this.$emit('input', this.selected);
    },

    preselectFirstCheck() {
      this.selected = this.options[0];
    },

    setOptions(localidadeId, secaoId, rotaId) {
      this.isLoading = true;
      let filter = `and business_logic.secao.id_localidade=${localidadeId}`;
      let colunas_adicionais = '';
      if (this.aditionalColumns && this.aditionalColumns.length) {
        colunas_adicionais += ` , ${this.aditionalColumns.toString()}`;
      }
      if (secaoId) filter += ` and business_logic.estabelecimento.id_secao=${secaoId}`;
      if (rotaId) filter += ` and business_logic.estabelecimento.id_rota=${rotaId}`;
      if (this.isContaCorrente) filter += ` and business_logic.estabelecimento.saldo_conta_corrente is true`;
      if (this.hasPos)
        filter += ` and business_logic.estabelecimento.configuracao->'gestorLoterico'->>'posId' is not null`;
      this.$atenaList
        .getEstabelecimentos({
          columns: `id, numero, nome ${colunas_adicionais}`,
          filter: filter,
          order: 'numero'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    localidadeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal, null, null);
      }
    },
    secaoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(this.localidadeSelected, newVal, null);
      }
    },
    rotaSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(this.localidadeSelected, this.secaoSelected, newVal);
      }
    }
  },

  created() {
    if (this.localidadeSelected || this.secaoSelected || this.rotaSelected) {
      this.setOptions(this.localidadeSelected, this.secaoSelected, this.rotaSelected);
    }
  }
};
</script>

<style lang="scss" scoped></style>
